import React from 'react';
import {reduxForm} from 'redux-form';
import {Alert} from 'elemental';
import ImageField from '../form/image-field';
import BaseForm from '../form/base-form';
import LocalizedStrings from '../../localization/strings';
import FormField from '../form/form-field';

const fields = ['imageId'];

function validate() {
    return [];
}
class PostForm extends BaseForm {

    render() {
        const { error, handleSubmit, fields: {
                imageId
            }} = this.props;
        return (
            <div>
                <form onSubmit={handleSubmit(this.submit.bind(this))}>
                    {error && <Alert type="error">{error}</Alert>}

                    <FormField label={LocalizedStrings.image} name="image" field={imageId}>
                        <ImageField {...imageId} onImageUploaded={this.props.onImageUploaded}></ImageField>
                    </FormField>

                </form>
            </div>
        )
    }
}

export default reduxForm({form: 'image-form', fields, validate, destroyOnUnmount: true})(PostForm);



// WEBPACK FOOTER //
// ./src/js/components/image/image-form.js